export default "__VITE_ASSET__HfDdg8fM__"